export default __webpack_public_path__ + "static/media/slider4.f27c227b.jpg";